import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../../styles/pages.css";
import Banner from "../ui/Banner";
import Boardimg from "../../assets/images/board.png";
import Pagination from "../ui/Pagination";
import SearchBar from "../ui/SearchBar";
import { getListBoardNotice, postContact } from "../../api";

const Board = () => {
  const navigate = useNavigate();
  const { tab } = useParams();
  const activeTab = tab || "contact";

  const handleTabChange = (tabId) => {
    navigate(`/board/${tabId}`);
  };

  const bannerConfig = {
    backgroundImage: Boardimg,
    title: "Q&A",
    description: ["문의 전에 한 번만 확인해보세요!", "빠르게 궁금증을 해결할 수 있는 핵심 정보만 모았습니다."],
    tabs: [
      { id: "contact", name: "견적문의" },
      { id: "notice", name: "공지사항" },
    ],
  };

  return (
    <div className="board-container">
      <Banner {...bannerConfig} activeTab={activeTab} onTabChange={handleTabChange} />
      {activeTab === "contact" && <ContactContent />}
      {activeTab === "notice" && <NoticeContent />}
    </div>
  );
};

const ContactContent = () => {
  const MAX_FILE_SIZE = 20 * 1024 * 1024;
  const ALLOWED_EXTS = ["jpg", "jpeg", "png", "pdf", "docx", "xls", "xlsx", "ppt", "pptx", "hwp"];

  const [formData, setFormData] = useState({
    company: "",
    name: "",
    phone: "",
    email: "",
    emailDomain: "",
    category: "작물파쇄",
    title: "",
    content: "",
    agreeToTerms: false,
  });

  const [customDomain, setCustomDomain] = useState("");
  const [isCustomDomain, setIsCustomDomain] = useState(true);
  const [file, setFile] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCustomDomainChange = (e) => {
    setCustomDomain(e.target.value);
    setFormData({
      ...formData,
      emailDomain: e.target.value,
    });
  };

  const handleEmailDomainChange = (e) => {
    const selectedDomain = e.target.value;
    setFormData({
      ...formData,
      emailDomain: selectedDomain,
    });

    if (selectedDomain === "") {
      setIsCustomDomain(true);
      setCustomDomain("");
    } else {
      setIsCustomDomain(false);
      setCustomDomain(selectedDomain);
    }
  };

  const handleCategoryClick = (category) => {
    setFormData({
      ...formData,
      category,
    });
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return setFile(null);
    if (selectedFile.size > MAX_FILE_SIZE) {
      alert("첨부파일 용량이 20MB를 초과합니다.");
      e.target.value = "";
      return;
    }
    const ext = (selectedFile.name.split(".").pop() || "").toLowerCase();
    if (!ALLOWED_EXTS.includes(ext)) {
      alert("등록 가능한 확장자가 아닙니다.");
      e.target.value = "";
      return;
    }
    setFile(selectedFile);
  };

  const handleCheckboxChange = (e) => {
    setFormData({
      ...formData,
      agreeToTerms: e.target.checked,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submitting) return;

    // 최종 이메일 조립
    const domain = isCustomDomain ? customDomain : formData.emailDomain;
    const finalEmail = `${formData.email}@${domain}`.trim();

    // 클라이언트 검증
    // if (!formData.company || !formData.name || !formData.phone || !formData.title || !formData.content) {
    //   alert("필수 항목을 모두 입력해 주세요.");
    //   return;
    // }
    // if (!domain) {
    //   alert("이메일 도메인을 입력하거나 선택해 주세요.");
    //   return;
    // }
    // if (!isValidEmail(finalEmail)) {
    //   alert("이메일 형식이 올바르지 않습니다.");
    //   return;
    // }
    // if (!isValidPhone(formData.phone)) {
    //   alert("전화번호 형식을 확인해 주세요.");
    //   return;
    // }
    // if (!formData.agreeToTerms) {
    //   alert("개인정보 수집 및 이용에 동의해 주세요.");
    //   return;
    // }

    // 페이로드 구성
    const data = {
      company: formData.company,
      name: formData.name,
      phone: formData.phone.replace(/\s|-/g, ""),
      email: finalEmail,
      inquiry: formData.category,
      title: formData.title,
      content: formData.content,
      file: formData.file,
    };

    setSubmitting(true);
    try {
      let response = await postContact(data);

      if ([200, 201, 202].includes(response.status)) {
        alert("문의가 접수되었습니다.");
        window.scrollTo(0, 0);
        setTimeout(() => {
          window.location.reload();
        }, 10);
      } else {
        alert("요청은 전송되었지만 응답이 예상과 다릅니다. 잠시 후 다시 시도해 주세요.");
      }
    } catch (err) {
      const status = err?.response?.status || 0;
      const data = err?.response?.data;
      if (status >= 500) {
        alert("서버 에러입니다. 잠시 후 다시 시도해 주세요.");
      } else if (data?.detail) {
        alert(data.detail);
      } else if (typeof data === "string") {
        alert(data);
      } else if (data && typeof data === "object") {
        const msgs = [];
        Object.entries(data).forEach(([k, v]) => {
          if (Array.isArray(v)) v.forEach((m) => msgs.push(`${k}: ${m}`));
          else if (typeof v === "string") msgs.push(`${k}: ${v}`);
        });
        alert(msgs.join("\n") || "요청을 처리할 수 없습니다. 입력값을 확인해 주세요.");
      } else {
        alert("네트워크 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="contact-section">
      <div className="contact-header">
        <h2>문의하기</h2>
        <p>최적화된 온실 솔루션을 전문가가 직접 안내해드립니다.</p>
        <p>성능과 가격, 시공 일정까지 꼼꼼히 비교해보세요.</p>
      </div>

      <form onSubmit={handleSubmit} className="contact-form">
        <div className="form-row">
          <div className="form-label">
            <label htmlFor="company">
              회사명 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <input type="text" id="company" name="company" value={formData.company} onChange={handleInputChange} placeholder="회사명을 입력해 주세요." required />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="name">
              이름 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <input type="text" id="name" name="name" value={formData.name} onChange={handleInputChange} placeholder="이름을 입력해 주세요." required />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="phone">
              전화번호 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleInputChange} placeholder="전화번호를 입력해 주세요." required />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="email">
              이메일 주소 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input email-group">
            <div className="email-input-container">
              <input type="text" id="email" name="email" className="email-field" value={formData.email} onChange={handleInputChange} placeholder="이메일 입력해 주세요." required />
              <span className="email-at">@</span>
              <input type="text" className="email-field" value={customDomain} onChange={handleCustomDomainChange} placeholder="직접 입력" disabled={formData.emailDomain !== ""} />
              <div className="email-domain-select-wrapper">
                <select value={formData.emailDomain} onChange={handleEmailDomainChange} className="email-field email-domain-select">
                  <option value="">직접 입력</option>
                  <option value="gmail.com">gmail.com</option>
                  <option value="naver.com">naver.com</option>
                  <option value="daum.net">daum.net</option>
                  <option value="hanmail.net">hanmail.net</option>
                  <option value="nate.com">nate.com</option>
                </select>
                <div className="select-arrow">
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="8" viewBox="0 0 14 8">
                    <path d="M1 1L7 7L13 1" stroke="#888" strokeWidth="2" fill="none" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="form-row formcontact">
          <div className="form-label">
            <label>
              문의 구분 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <div className="category-buttons">
              <button type="button" className={`category-button ${formData.category === "작물파쇄" ? "active" : ""}`} onClick={() => handleCategoryClick("작물파쇄")}>
                작물파쇄
              </button>
              <button type="button" className={`category-button ${formData.category === "소모자재" ? "active" : ""}`} onClick={() => handleCategoryClick("소모자재")}>
                소모자재
              </button>
              <button type="button" className={`category-button ${formData.category === "차광/세척제" ? "active" : ""}`} onClick={() => handleCategoryClick("차광/세척제")}>
                차광/세척제
              </button>
              <button type="button" className={`category-button ${formData.category === "소독제" ? "active" : ""}`} onClick={() => handleCategoryClick("소독제")}>
                소독제
              </button>
              <button type="button" className={`category-button ${formData.category === "온실개폐장치" ? "active" : ""}`} onClick={() => handleCategoryClick("온실개폐장치")}>
                온실개폐장치
              </button>
              <button type="button" className={`category-button ${formData.category === "기계장비" ? "active" : ""}`} onClick={() => handleCategoryClick("기계장비")}>
                기계장비
              </button>
              <button type="button" className={`category-button ${formData.category === "시공" ? "active" : ""}`} onClick={() => handleCategoryClick("시공")}>
                시공
              </button>
              <button type="button" className={`category-button ${formData.category === "유지보수" ? "active" : ""}`} onClick={() => handleCategoryClick("유지보수")}>
                유지보수
              </button>
              <button type="button" className={`category-button ${formData.category === "기타" ? "active" : ""}`} onClick={() => handleCategoryClick("기타")}>
                기타
              </button>
            </div>
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="title">
              제목 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <input type="text" id="title" name="title" value={formData.title} onChange={handleInputChange} placeholder="16자 이내로 입력해 주세요." maxLength="16" required />
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="content">
              내용 <span className="required">*</span>
            </label>
          </div>
          <div className="form-input">
            <textarea id="content" name="content" value={formData.content} onChange={handleInputChange} placeholder="500자 이내로 입력해 주세요." maxLength="500" rows="6" required></textarea>
          </div>
        </div>

        <div className="form-row">
          <div className="form-label">
            <label htmlFor="file">첨부파일</label>
          </div>
          <div className="form-input">
            <div className="file-upload-container">
              <input type="text" className="file-display" placeholder="첨부파일" value={file ? file.name : ""} readOnly />
              <input type="file" id="file" onChange={handleFileChange} className="file-input" />
              <button type="button" className="file-upload-button" onClick={() => document.getElementById("file").click()}>
                파일 찾기
              </button>
            </div>
            <div className="file-info">
              <p>• 첨부파일 용량은 최대 20MB을 넘을 수 없습니다.</p>
              <p>• 등록 가능한 확장자명은 jpg, jpeg, png, pdf, docx, xls, xlsx, ppt, pptx, hwp 입니다.</p>
              <p>• 첨부 가능한 파일 갯수는 1개 입니다.</p>
            </div>
          </div>
        </div>

        <div className="privacy-agreement">
          <h3>개인정보 수집 및 이용</h3>
          <div className="privacy-content">
            <p>(주)에코텍글로벌은 귀하가 제공하는 개인정보가 「개인정보 보호법」 등 관련 법령에 따라 개인정보보호 규정을 준수하여 수집·보유·처리되고 있습니다.</p>
            <p>귀하의 개인정보 수집·이용 및 제3자 제공과 관련하여 아래의 내용을 정확히 숙지하시고 동의여부를 결정하여 주시기 바랍니다.</p>

            <ol>
              <li>
                개인정보의 수집 항목
                <p>(1) 필수 : 성명, 연락처, 이메일 주소, 상담 문의 내용 (제목, 내용), 기업명, 직급</p>
                <p>(2) 선택 : 사업정보, 첨부 파일</p>
              </li>

              <li>
                개인정보의 이용목적
                <p>수집한 개인정보를 아래와 같은 목적을 위해 활용합니다.</p>
                <p>(1) 문의에 대한 답변 전달</p>
              </li>

              <li>
                개인정보의 보유 및 이용기간
                <p>아래와 같이 동의받은 이용자의 개인정보를 이용 보관함을 원칙으로 하며, 보유 기간 이후 해당 정보를 지체 없이 파기 합니다.</p>
                <p>(1) 이메일 문의, 상담 이용 시 수집된 개인정보 : 3년</p>
              </li>

              <li>
                동의 거부권 및 미동의에 대한 불이익 안내
                <p>본 개인정보 수집 이용에 대해 거부하실 수 있으며, 미동의 시 상담 이용에 제약이 있을 수 있습니다.</p>
              </li>
            </ol>
          </div>
        </div>
        <div className="agreement-checkbox">
          <input type="checkbox" id="agreeToTerms" checked={formData.agreeToTerms} onChange={handleCheckboxChange} required />
          <label htmlFor="agreeToTerms">(필수) 개인정보수집 및 이용에 대한 약관에 동의합니다.</label>
        </div>
        <div className="submit-button-container">
          <button type="submit" className="submit-button" disabled={!formData.agreeToTerms}>
            문의하기
          </button>
        </div>
      </form>
    </div>
  );
};

const NoticeContent = () => {
  const navigate = useNavigate();

  // Pagination 시작
  const [currentPage, setCurrentPage] = useState(1);
  const [displayedNotices, setDisplayedNotices] = useState([]);
  const noticesPerPage = 15;
  const [dataCount, setDataCount] = useState(1);
  // Pagination 끝

  // 검색바
  // const [originalNotices, setOriginalNotices] = useState([]);
  // const [filteredNotices, setFilteredNotices] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [hoveredItemId, setHoveredItemId] = useState(null);

  // 초기 로드 시 모든 공지사항 설정
  useEffect(() => {
    (async () => {
      const res = await getListBoardNotice({
        category: "공지",
        page: currentPage,
        search: searchTerm.trim() || undefined,
      });
      const data = res.data.results;
      setDataCount(res.data.count);
      setDisplayedNotices(data);
    })();
  }, [currentPage, searchTerm]);

  // 검색어에 따라 공지사항 필터링
  useEffect(() => {
    // if (searchTerm.trim() === "") {
    //   setFilteredNotices(originalNotices);
    // } else {
    //   const filtered = originalNotices.filter(
    //     (notice) =>
    //       notice.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    //       notice.notice_content.toLowerCase().includes(searchTerm.toLowerCase())
    //   );
    //   setFilteredNotices(filtered);
    // }
    setCurrentPage(1); // 검색 시 첫 페이지로 이동
  }, [searchTerm]);

  // 페이지 변경 시 표시할 공지사항 업데이트
  // useEffect(() => {
  //   const indexOfLastNotice = currentPage * noticesPerPage;
  //   const indexOfFirstNotice = indexOfLastNotice - noticesPerPage;
  //   setDisplayedNotices(filteredNotices.slice(indexOfFirstNotice, indexOfLastNotice));
  // }, [currentPage, filteredNotices]);

  const handleNoticeClick = (id) => {
    navigate(`/board/notice/${id}/`);
  };

  const handlePageChange = (pageNumber) => {
    const target = Math.max(1, Math.min(pageNumber, totalPages));
    setCurrentPage((prev) => (prev === target ? prev : target));
    window.scrollTo({
      top: document.querySelector(".notice-section").offsetTop - 100,
      behavior: "smooth",
    });
  };

  const handleSearch = (term) => {
    setCurrentPage(1);
    setSearchTerm(term);
  };

  const totalPages = Math.ceil((dataCount ?? 0) / noticesPerPage);

  return (
    <div className="notice-section">
      <div className="productarea-header">
        <h2>공지사항</h2>
        <p>에코텍글로벌의 새로운 소식과 안내를 확인하세요.</p>
      </div>
      <div className="productarea-info">
        <p>총 {dataCount}건</p>
        <SearchBar onSearch={handleSearch} placeholder="검색어를 입력하세요." />
      </div>
      <hr />
      <div className="notice-list">
        {displayedNotices.map((notice) => (
          <div key={notice.id} className="notice-item" onClick={() => handleNoticeClick(notice.id)} onMouseEnter={() => setHoveredItemId(notice.id)} onMouseLeave={() => setHoveredItemId(null)}>
            <div className="notice-info">
              <p className="date">{notice.created_date}</p>
              <p className="year">{notice.created_year}</p>
            </div>
            <div className="notice-title">
              <p className="title">
                {notice.top_fixed && (
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: "8px", verticalAlign: "middle" }}>
                    <path
                      d="M16 3H8C7.44772 3 7 3.44772 7 4V7C7 7.55228 7.44772 8 8 8H8.5V14.5L6 18H18L15.5 14.5V8H16C16.5523 8 17 7.55228 17 7V4C17 3.44772 16.5523 3 16 3Z"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path d="M12 18V21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                )}
                {notice.title}
              </p>
              <p className="description">{notice.notice_content_text}</p>
            </div>
            <div className="notice-detail">
              <svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" className="arrow-circle">
                <g data-name="그룹 66">
                  <g data-name="타원 2">
                    <circle
                      cx="27"
                      cy="27"
                      r="27"
                      style={{
                        stroke: "none",
                        fill: hoveredItemId === notice.id ? "#3076bc" : "#fff",
                        transition: "fill 0.3s ease",
                      }}
                    />
                    <circle
                      cx="27"
                      cy="27"
                      r="26.5"
                      style={{
                        fill: "none",
                        stroke: hoveredItemId === notice.id ? "#3076bc" : "#676767",
                        transition: "stroke 0.3s ease",
                      }}
                    />
                  </g>
                  <g data-name="그룹 64">
                    <path
                      data-name="패스 46"
                      d="M19177 1666.584h14.877"
                      transform="translate(-19157 -1639.662)"
                      style={{
                        strokeLinecap: "round",
                        fill: "none",
                        stroke: hoveredItemId === notice.id ? "#fff" : "#676767",
                        transition: "stroke 0.3s ease",
                      }}
                    />
                    <path
                      data-name="패스 47"
                      d="m19424.426 1615.443 6.922 6.922-6.922 6.922"
                      transform="translate(-19396.471 -1595.443)"
                      style={{
                        strokeLinecap: "round",
                        fill: "none",
                        stroke: hoveredItemId === notice.id ? "#fff" : "#676767",
                        transition: "stroke 0.3s ease",
                      }}
                    />
                  </g>
                </g>
              </svg>
            </div>
          </div>
        ))}
      </div>

      {totalPages > 1 && <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />}
    </div>
  );
};

export default Board;
